var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`credit-card-icon ${_vm.classes}`,style:(_vm.styles)},[_c('img',{attrs:{"src":_vm.url,"alt":_vm.text}})])
}
var staticRenderFns = []

export { render, staticRenderFns }